module.exports = __webpack_public_path__ + "img/زيتون-صورة.fc06fe9c.png";